import { TConsistencyTrendData } from 'types/models/DataAnalysis'

const series = [
  { key: 'consistent', name: 'Consistent', color: '#36C24C' },
  { key: 'borderline', name: 'Borderline', color: '#dbaf10ff' },
  { key: 'inconsistent', name: 'Inconsistent', color: '#FF0009' },
]

export const toConsistencyTrendChartData = (
  arr: TConsistencyTrendData[],
  mode: 'count' | 'percentage' = 'count'
): { rows: any[]; series: { key: string; name: string; color: string }[] } => {
  if (!Array.isArray(arr) || arr.length === 0) return { rows: [], series: [] }

  const rows = arr.map((item) => {
    const counts: Record<string, number> = {
      consistent: item.consistent_count,
      borderline: item.borderline_count,
      inconsistent: item.inconsistent_count,
    }
    const total = item.total_count || 0

    const valueFor = (k: string) =>
      mode === 'count'
        ? counts[k]
        : total > 0
          ? Number(((counts[k] / total) * 100).toFixed(2)) // 0–100
          : 0

    return {
      wheatLabel: `Wheat ${item.wheat_code}`,
      consistent: valueFor('consistent'),
      borderline: valueFor('borderline'),
      inconsistent: valueFor('inconsistent'),
      total: total,
      score: item.score,
    }
  })

  return { rows, series }
}
